import { render } from "./HackathonStatus.vue?vue&type=template&id=646ce190"
import script from "./HackathonStatus.vue?vue&type=script&lang=js"
export * from "./HackathonStatus.vue?vue&type=script&lang=js"
script.render = render

export default script